import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {
    AppNotificationService,
    AppNotificationType,
    ConnectivityService,
    CseSalesTidInputModel,
    ENDPOINTS,
    MaterialQuoteModel,
    ModalClass,
    ODataCseSalesTidInput,
    OnlineOnlyService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { MaterialQuoteComponent } from '../material-quote/material-quote.component';

@Component({
    selector: 'pace-cse-sales-tid-input',
    templateUrl: './cse-sales-tid-input.component.html',
    styleUrls: ['./cse-sales-tid-input.component.scss'],
})
export class CseSalesTidInputComponent implements OnInit {
    @Input()
    public model: CseSalesTidInputModel;

    public isLoading: boolean;
    public formChildren: FormArray;
    public cseSalesTidInputForm: FormGroup;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly formBuilder: FormBuilder,
        private readonly translate: TranslateService,
        private readonly onlineOnlyService: OnlineOnlyService,
        private readonly appNotificationService: AppNotificationService,
        public readonly modalInstance: BsModalRef,
        private readonly modalService: BsModalService,
        private readonly connectivityService: ConnectivityService,
    ) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.cseSalesTidInputForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        this.model = new CseSalesTidInputModel();
    }

    public validateForm(): void {
        this.model.resetRequiredOption();
        this.formChildren.controls.forEach((control) => {
            control.updateValueAndValidity();
        });
        this.changeDetector.detectChanges();
    }

    /**
     * Send the order or request to the backend
     */
    public submit(): void {
        const outModel = this.model.getOutModel();
        this.isLoading = true;
        this.onlineOnlyService
            .post<ODataCseSalesTidInput>(ENDPOINTS.CseSale, outModel)
            .pipe(
                take(1),
                tap((data: ODataCseSalesTidInput) => {
                    // TODO - check if it is working
                    if (data.NotificationNo.length < 1) {
                        this.appNotificationService.setAppNotification(
                            AppNotificationType.ERROR,
                            <string>this.translate.instant('DASHBOARD_SIDEMENU_SALES_QUOTE_INVALID_DATA_TITLE'),
                            <string>this.translate.instant('DASHBOARD_SIDEMENU_SALES_QUOTE_INVALID_DATA_BODY'),
                        );
                    } else {
                        this.modalInstance.hide();
                        this.modalService.show(MaterialQuoteComponent, {
                            backdrop: 'static',
                            class: ModalClass.MODAL_LARGE,
                            initialState: {
                                model: new MaterialQuoteModel(data),
                            },
                            ariaLabelledBy: 'material-quote-modal-title',
                        });
                    }
                }),
                catchError((error) => {
                    this.log.error('Error sending outmodel to NotiCreateSet: ', error, `${outModel}`);
                    const isOnline = this.connectivityService.isInternetConnectionAvailable();
                    if (!isOnline) {
                        this.appNotificationService.setAppNotification(
                            AppNotificationType.WARN,
                            <string>this.translate.instant('DASHBOARD_SIDEMENU_SALES_QUOTE_ERROR_TITLE'),
                            <string>this.translate.instant('DASHBOARD_SIDEMENU_CUSTOMER_LEAD_OFFLINE_ERROR_BODY'),
                        );
                    } else {
                        this.appNotificationService.setAppNotification(
                            AppNotificationType.ERROR,
                            <string>this.translate.instant('DASHBOARD_SIDEMENU_SALES_QUOTE_ERROR_TITLE'),
                            `${<string>(
                                this.translate.instant('DASHBOARD_SIDEMENU_SALES_QUOTE_ERROR_BODY')
                            )} ${JSON.stringify(error)}`,
                        );
                    }
                    return of(undefined);
                }),
            )
            .subscribe(() => (this.isLoading = false));
    }
}
